<template>
  <div class="mt-8 quick-access-main-nav" role="navigation" aria-label="Acceso rápido menú principal">
    <div class="bg-white dark:bg-darkblue-900 shadow rounded cursor-pointer">
      <button
        class="w-full group flex items-center justify-between pr-1 py-1"
        @click="toggle"
        :aria-expanded="active ? 'true' : 'false'"
        aria-controls="aside-main-nav-list"
        aria-label="Alternar menú principal"
      >
        <div class="qa-nav-child-hamburguer flex items-center">
          <span class="flex-none w-8 flex items-center justify-center">
            <base-icon
              name="hamburguer"
              title="Desplegar menú de navegación y opciones"
              size="sm"
              class="group-hover:text-primary dark:text-darkblue-400 transition-colors duration-300"
            />
          </span>
          <span
            :class="{'opacity-0':active}"
            class="qa-nav-child-label-nav text-sm text-secondary dark:text-darkblue-200 group-hover:text-primary ml-1 transition-all duration-300 ease-out"
          >Menú</span>
        </div>
        <span class="hover:bg-primary-100 dark:hover:bg-darkblue-600 rounded animate-hover">
          <span
            :class="{ 'rotate-180': active }"
            class="dark:text-darkblue-400 dark:hover:text-primary w-8 h-7 flex-none flex items-center justify-center cursor-p transform transition-transform duration-300"
          >
            <base-icon
              name="chevrondown"
              size="sm"
              :title="active ? 'Contraer submenú' : 'Desplegar submenú'" 
            />
          </span>
        </span>
      </button>
      <transition
        name="navigation"
        @enter="startTransition"
        @after-enter="endTransition"
        @before-leave="startTransition"
        @after-leave="endTransition"
      >
        <base-aside-nav
          v-if="active"
          :items="items"
          data-type="main"
          class="overflow-hidden"
          id="aside-main-nav-list"
        />
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'base-aside-main-nav',
  props: {
    items: {
      type: [Object, Array],
      required: true
    }
  },
  data: function () {
    return {
      active: false
    }
  },
  methods: {
    toggle: function () {
      this.active = !this.active
      this.$emit('cover')
    },
    startTransition: function (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition: function (el) {
      el.style.height = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.navigation-enter-active,
.navigation-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.navigation-enter,
.navigation-leave-to {
  height: 0 !important;
}
</style>
